export default __webpack_public_path__ + "dc4a21c88f4d507938688b7f48432a7e.svg";